<template>
    <el-form :model="form" ref="form" :rules="rules" :inline-message="true">
        <slot name="head"></slot>
        <el-form-item label="学校域名:" label-width="120px" prop="cor_domain">
            <el-col :span="8">
                <el-input size="mini" v-model="form.cor_domain"  @blur="handleDataInit" ><i slot="append">{{this.domain_suffix}}</i></el-input>
            </el-col>
            <el-col :span="6" :offset="1">
                <el-button type="text" @click="copyDomain(form.cor_domain)">复制地址</el-button>
            </el-col>
        </el-form-item>
        <el-form-item label="登录页封面:" label-width="120px" prop="login_template">
            <el-radio-group v-model="form.login_template" @change="handleDataInit">
                <el-radio :label="0">
                    模板一（默认公共模板）
                    <img 
                        :src="temp1Image" 
                        alt="模板1预览" 
                        class="template-thumbnail" 
                        @click.stop="previewTemplate(temp1Image)"
                        title="点击放大预览"
                    />
                </el-radio>
                <el-radio :label="1">
                    模板二（学海行舟公益性专享）
                    <img 
                        :src="temp2Image" 
                        alt="模板2预览" 
                        class="template-thumbnail" 
                        @click.stop="previewTemplate(temp2Image)"
                        title="点击放大预览"
                    />
                </el-radio>
                <el-radio :label="2">
                    模板三（江苏徐州代理二一优作业定制模板）
                    <img
                        :src="temp3Image"
                        alt="模板3预览"
                        class="template-thumbnail"
                        @click.stop="previewTemplate(temp3Image)"
                        title="点击放大预览"
                    />
                </el-radio>

            </el-radio-group>
        </el-form-item>
        <el-form-item label="学校Logo:" label-width="120px" prop="fileList">
                <el-upload  class="upload-demo" name="contractFile" action="api/order/upload" :headers=headers :on-error="uploadError" :on-success="uploadSuccess" :on-preview="handlePreview" :on-remove="handleRemove" :file-list="form.fileList" :beforeUpload="beforeUpload" :limit="1" :on-exceed="handleExceed" list-type="picture" @change="handleDataInit">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb(<span style="color:red">只允许上传一张图片</span>)</div>
                </el-upload>
        </el-form-item>
        <el-form-item label="备注：" label-width="100px" class="limit-configure" prop="memo">
            <el-input style="width: 300px;" type="textarea"  v-model="form.memo"
                      @input="emit"></el-input>
        </el-form-item>
        <el-dialog :visible.sync="dialogVisible" :append-to-body='true'>
        <img width="100%" :src="dialogImageUrl" alt>
        </el-dialog>
        
        <el-dialog :visible.sync="templatePreviewVisible" :append-to-body='true' width="80%">
            <img width="100%" :src="templatePreviewUrl" alt="模板预览">
        </el-dialog>
        
    </el-form>
    
</template>
<script>
import AttachmentService from "~/services/attachment";
import CommonService from "~/services/common";
const temp1Image = require('~/assets/temp1x.png');
const temp2Image = require('~/assets/temp2x.png');
const temp3Image = require('~/assets/temp3x.png');


export default {
    components:{
    },
    data() {

        var check_domain_url = (rule, value, callback) => {
                if(!value){
                    callback(new Error('请设置合作域名'));
                }
                CommonService.checkUrlIsExist({url:this.form.cor_domain_url,type:this.domain_suffix}).then(res=>{

                    if(!res.data.domain_url){
                        callback();
                    }
                    if(res.data.domain_url == this.form.cor_domain_url && res.data.customer_id != this.$route.query['id']){
                        callback(new Error('合作域名已经存在'));
                    }
                    callback();
                    
                });
        }

        return {
            dialogVisible:false,
            dialogImageUrl:'',
            templatePreviewVisible: false,
            templatePreviewUrl: '',
            temp1Image: temp1Image,
            temp2Image: temp2Image,
            temp3Image: temp3Image,
            form:{
                cor_domain:'',
                cor_domain_url:'',
                login_template: 0,
                fileList: [],
                memo:'',
            },
            headers:{
                "access-token":this.$store.getters.token
            },
            rules:{
                cor_domain: [
                    { required: true, validator: check_domain_url, trigger: 'change' },
                ],
            },
        };
    },
    mounted(){

        if(this.params !== null){
            this.form = Object.assign({},this.params);
            if(typeof(this.form.fileList)=='undefined'){
                this.form.fileList = [];
            }
            // 确保 login_template 有默认值
            if(typeof(this.form.login_template)=='undefined' || this.form.login_template === null){
                this.form.login_template = 0;
            }
        }

        if(this.head_params !== undefined && this.head_params !== null && this.head_params['config'] !== null) {
            this.form.memo = this.head_params['config']['memo']
        }
        if(this.head_params !== undefined && this.head_params !== null && this.form.memo == null && this.head_params['config']['basic_configure']['memo']) {//此处为啥这样写，因为之前其他产品备注放的位置不统一
            this.form.memo = this.head_params['config']['basic_configure']['memo']
        }
    },
    watch:{

        'form.cor_domain':function(val){
            this.form.cor_domain_url = val + '.' + this.domain_suffix;
        },
    },
    props:{
            params:{
                required:true
            },
            head_params:{
                required:true
            },
            domain_suffix:{
                type:String,
                required:true,
            }
    },
    methods: {
        /**
         * 验证表单
         */
        validateForm(cb){
            let flag = false;
            this.$refs["form"].validate((valid) => {
                if(valid){
                    flag = valid;
                }
                if (typeof cb === 'function') cb(flag)
                return flag
            });
        },

        handleExceed(file, fileList){
            this.$message.warning(`只允许上传一张图片，请删除在进行重新上传`);
        },
        handleDataInit(){
            this.$emit("handleDataInit",this.form);
        },
        emit() {
            this.$forceUpdate();
            this.$emit('getMemo', this.form);
        },

        /**@description 图片是上传处理 */
        handleRemove(file, fileList) {
            AttachmentService.del({file_path:file.url}).then(res=>{
                    this.form.fileList = [];
                });
        },
        handlePreview(file) {
            this.dialogVisible = true;
            this.dialogImageUrl = file.url;
        },
        uploadSuccess(response, file, fileList){
            if(response.code>0){
                this.$message({
                        message: response.msg,
                        type: 'error'
                }); 
            }else{
                this.form.fileList.push({"name":response.data.file_name,"url":response.data.file_path});
            }
            this.handleDataInit();
        },
        uploadError(err, file, fileList){
            this.$message({
                        message: err,
                        type: 'error'
                }); 
        },
        beforeUpload(file){
            let extension = file.name.split('.')[1];
            let filesize = file.size / 1024 / 1024 < 5;
            let type = ['jpg','jpeg','png'];
            if(!_.includes(type,extension)){
                this.$message({
                        message: '上传格式不允许,只允许上传jpg,jpeg,png格式文件',
                        type: 'tips'
                }); 
                return false;
            }

            if (!filesize) {
                this.$message({
                        message: '上传文件大小不能超过5M',
                        type: 'error'
                });
                return false;
            }
        },

        copyDomain(domain) {
            const textToCopy = domain + '.' + this.domain_suffix;
            navigator.clipboard.writeText(textToCopy).then(
                () => this.$message({
                message: '复制成功',
                type: 'success'
                }),
                () => this.$message({
                message: '复制失败',
                type: 'error'
                })
            );
        },
        
        previewTemplate(url) {
            this.templatePreviewUrl = url;
            this.templatePreviewVisible = true;
        }
    }
}
</script>

<style scoped>
.template-thumbnail {
    width: 80px;
    height: 50px;
    margin-left: 10px;
    margin-top: 5px;
    border: 1px solid #ddd;
    border-radius: 4px;
    cursor: pointer;
    object-fit: cover;
    transition: all 0.3s;
    display: inline-block;
    vertical-align: middle;
}

.template-thumbnail:hover {
    border-color: #409EFF;
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
    transform: scale(1.05);
}

.el-radio {
    display: block;
    margin-bottom: 15px;
    line-height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/order/jiaoben/basicConfigure.vue